var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 190,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.425 0h74.551v76.392h-74.551V0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164.834 -81.76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 207.64 215.548)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.135.644-2.71 1.05-3.999 1.05-2.558 0-4.404-1.694-4.404-4.286 0-2.474 1.372-3.017 3.456-3.609.712-.204 2.017-.526 2.017-1.458 0-.898-.831-1.288-1.61-1.288-1.136 0-2.118.593-2.949 1.322l-1.423-2.677c1.305-.915 2.88-1.457 4.49-1.457 1.288 0 2.626.356 3.626 1.203C.221-10.336.526-9.031.526-7.76c0 2.067-1.373 2.965-3.151 3.49l-.848.254c-.576.187-1.474.475-1.474 1.22 0 .712.813 1.068 1.424 1.068.813 0 1.591-.339 2.202-.847L0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 231.291 224.694)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h2.745v2.813h-8.81V0h2.744v-9.963H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M259.01 212.447h-14.46v55.631h14.46v-55.63z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 292.78 224.694)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v2.813h-7.337V-9.963h3.321v5.014h3.643v2.814h-3.643V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 319.761 224.694)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h2.745v2.813h-8.811V0h2.745v-9.963H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 366.814 212.448)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v-6.728c0-1.66-.119-3.473-2.255-3.473-2.135 0-2.252 1.813-2.252 3.473V0H-7.83v-7.185c0-1.643.069-3.27 1.339-4.506 1.068-1.052 2.746-1.424 4.236-1.424 1.492 0 3.169.372 4.237 1.424C3.253-10.455 3.32-8.828 3.32-7.185V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 382.795 268.078)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h3.32v7.828h.034L9.438 0h3.322v12.776H9.438V4.965h-.034L3.32 12.776H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 464.752 237.015)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v-2.61h2.711C2.576-4.084 1.474-4.83.034-4.83c-2.185 0-3.372 2.017-3.372 3.999 0 1.949 1.134 4.033 3.321 4.033 1.338 0 2.304-.813 2.761-2.034L5.896 2.49C4.795 4.879 2.762 6.066.135 6.066c-4.117 0-6.931-2.728-6.931-6.88 0-4.016 2.797-6.744 6.813-6.744 2.135 0 4.015.763 5.27 2.508C6.422-3.457 6.557-1.865 6.591 0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 202.994 161.09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v2.813h-7.27V-9.963H0v2.812h-3.948v2.203h3.744v2.813h-3.744V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 219.055 181.453)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h.339c1.085 0 2.728.152 2.728-1.39 0-1.406-1.66-1.355-2.643-1.355H0V0zm1.796-5.287c2.339 0 4.626.881 4.626 3.559 0 1.779-.779 3.016-2.609 3.253v.034c1.033.525 1.406 1.457 1.406 2.61 0 2.439-1.525 3.321-3.795 3.321h-4.745V-5.287h5.117zM0 4.948h.238c.898 0 1.931-.068 1.931-1.237 0-1.085-.915-1.238-1.796-1.238H0v2.475z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 275.914 161.09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v2.813h-7.269V-9.963H0v2.812h-3.948v2.203h3.745v2.813h-3.745V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 306.29 181.674)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.813.322 2.795 1.847 2.795 3.609 0 2.728-1.914 3.931-4.439 3.931h-4.965V-5.236h3.322v4.914h.034l3.134-4.914h4.135L0 0zm-3.287 4.999h.322c1.084 0 2.304-.204 2.304-1.593 0-1.39-1.22-1.593-2.304-1.593h-.322v3.186z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 346.191 161.09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h2.744v2.813h-8.811V0h2.745v-9.963H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 203.288 97.484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v2.813h-7.337V-9.963h3.321v5.016h3.644v2.813h-3.644V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 232.792 118.069)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.813.322 2.795 1.847 2.795 3.609 0 2.728-1.914 3.931-4.439 3.931h-4.964V-5.235h3.321v4.913h.034l3.135-4.913h4.134L0 0zm-3.287 4.999h.321c1.085 0 2.305-.204 2.305-1.593s-1.22-1.593-2.305-1.593h-.321v3.186z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M260.591 85.236h-14.465v55.626h14.465V85.236z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 294.375 97.484)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v2.813h-7.269V-9.963H0v2.813h-3.948v2.203h3.745v2.813h-3.745V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 295.972 140.865)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0h4.711C8.253 0 11.2 2.796 11.2 6.388s-2.93 6.387-6.489 6.387H0V0zm3.321 9.963h.78c2.135 0 3.643-1.288 3.643-3.575 0-2.491-1.694-3.575-3.677-3.575h-.746v7.15z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 370.718 118.069)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c1.813.322 2.795 1.847 2.795 3.609 0 2.728-1.914 3.931-4.439 3.931h-4.964V-5.235h3.321v4.913h.034l3.134-4.913h4.135L0 0zm-3.287 4.999h.322c1.084 0 2.304-.204 2.304-1.593s-1.22-1.593-2.304-1.593h-.322v3.186z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M398.514 85.236h-14.456v55.626h14.456V85.236z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 438.946 86.564)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-.984.407-1.967.644-3.033.644-1.797 0-3.611-.779-4.865-2.067a6.69 6.69 0 01-1.879-4.678c0-1.896.643-3.557 2.049-4.828 1.323-1.203 3.016-1.881 4.794-1.881 1.035 0 1.831.254 2.934.594v3.981c-.696-.83-1.78-1.356-2.865-1.356-2.067 0-3.456 1.458-3.456 3.474 0 1.983 1.372 3.541 3.405 3.541 1.136 0 2.237-.491 2.916-1.406V0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 455.011 106.705)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005697",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0v4.93h-3.32V-7.845H0v5.235h4.796v-5.235h3.321V4.93H4.796V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 358.425 159.78)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#005697",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M0 0h13.224M2.376 2.681h8.47m-9.75-1.158h11.09M-.672-1.646h14.625M.729-8.41H12.49M-.61-5.972h14.441M-.976-3.535h15.174"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.35431 0 0 -4.35431 373.542 159.78)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#005697",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 0.366,
    d: "M0 0l3.109 3.169L6.278 0M3.109-11.212V3.169m-7.556-6.825c0 4.144 3.412 7.555 7.556 7.555 4.204 0 7.678-3.411 7.678-7.555 0-4.205-3.474-7.618-7.678-7.618-4.144 0-7.556 3.413-7.556 7.618z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFesLogo);
export default __webpack_public_path__ + "static/media/fes-logo.aeee7acaf56afdb32e21481932afc33b.svg";
export { ForwardRef as ReactComponent };